"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalSelectCarGenerationList = void 0;
var react_1 = __importDefault(require("react"));
var ModalSelectList_module_scss_1 = __importDefault(require("./ModalSelectList.module.scss"));
var selectors_1 = require("../../redux/selectors");
var modalSlice_1 = require("../../redux/slice/modalSlice");
var react_redux_1 = require("react-redux");
var createUrl_1 = require("../../helpers/car/createUrl");
var ModalSelectCarGenerationList = function () {
    var dispatch = (0, react_redux_1.useDispatch)();
    var brand = (0, react_redux_1.useSelector)(selectors_1.modalSelector).selectCar.filter.brand.selected;
    var model = (0, react_redux_1.useSelector)(selectors_1.modalSelector).selectCar.filter.model.selected;
    var setGenerationFilter = function (configValue) {
        dispatch((0, modalSlice_1.setFilterGeneration)(configValue));
    };
    var filterList = (0, react_redux_1.useSelector)(selectors_1.modalSelector).selectCar.filter.generation.thisValue;
    return (react_1.default.createElement("ul", { className: ModalSelectList_module_scss_1.default.modal_select__list }, filterList.map(function (item) {
        var filter = item;
        return (react_1.default.createElement("li", { className: ModalSelectList_module_scss_1.default.modal_select__item, key: filter.name, onClick: function () {
                setGenerationFilter({
                    thisValue: filterList,
                    nextValue: [],
                    status: true,
                    selected: filter.name,
                });
                dispatch((0, modalSlice_1.selectCarsLoader)((0, createUrl_1.createUrl)(brand, model, filter.name, null)));
            } },
            filter.name,
            " ",
            react_1.default.createElement("span", null, filter.count)));
    })));
};
exports.ModalSelectCarGenerationList = ModalSelectCarGenerationList;
